import React from "react";
import { SectionLabel } from "./ui";

const FNS = [
  { tag: "01", t: "Sales & Distribution",  d: "Prospecting, quoting, channel orchestration — agents that sell while your team sleeps." },
  { tag: "02", t: "Customer Experience",   d: "Resolves, retains and upsells in 22 languages, every channel, 24/7." },
  { tag: "03", t: "Procurement & Supply",  d: "Sourcing, KYB, contract intelligence, risk monitoring." },
  { tag: "04", t: "Inventory & Warehouse", d: "Real-time stock, replenishment, slotting and pick optimization." },
  { tag: "05", t: "Finance & AR",          d: "Receivables, reconciliation, collections, embedded credit decisions." },
  { tag: "06", t: "Field & Service Ops",   d: "Dispatch, delivery and field-team agents that adapt to disruptions." },
  { tag: "07", t: "Marketing Intelligence",d: "Segment, personalize, test and attribute — campaigns on autopilot." },
  { tag: "08", t: "Compliance & Risk",     d: "Always-on monitoring, anomaly catching, policy enforcement, audit trails." },
];

export default function FunctionsSection() {
  return (
    <section className="relative bg-[#060c22] py-24 lg:py-32 border-y border-white/[0.05]">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-3xl">
          <SectionLabel tone="amber">One platform · every function</SectionLabel>
          <h2 className="mt-5 text-[36px] leading-[1.05] tracking-tight sm:text-[44px] lg:text-[52px]">
            <span className="text-white">Eight functional teams,</span>{" "}
            <span className="font-display italic grad-text">one agent fabric.</span>
          </h2>
          <p className="mt-5 max-w-2xl text-[16px] leading-relaxed text-white/65">
            Each agent is purpose-built — but they collaborate. Your AR agent talks to your CX agent. Your demand agent talks to your supply agent. The fabric is where compounding leverage comes from.
          </p>
        </div>
        <div className="mt-12 grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-4">
          {FNS.map(f => (
            <div key={f.tag} className="group rounded-2xl border border-white/[0.06] bg-white/[0.025] p-6 hover:border-cyan-300/30 hover:bg-white/[0.05]">
              <div className="flex items-center justify-between">
                <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-cyan-300/70">{f.tag}</span>
                <span className="text-white/30 group-hover:text-cyan-300">↗</span>
              </div>
              <h3 className="mt-5 text-[16px] font-semibold tracking-tight text-white">{f.t}</h3>
              <p className="mt-2 text-[13px] leading-relaxed text-white/55">{f.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
